export default __webpack_public_path__ + "static/media/verify_device.d090afb1.png";